import { PricingItem } from "src/app/core/models/quote/pricing-item/pricing-item";
import { ConsumablePricingItem } from 'quote-export-manager-core';
import { KeyValue } from '@angular/common';
import { BillingLine } from 'src/app/core/models/billing-line/billing-line.model';
import { ProductPricingV2 } from "src/app/core/models/productv2/productpricingv2.model";
import { DiscoPricingItemInitializer } from "../disco.pricing-item-initializer";
import {ProductV2} from '../../../../core/models/productv2/productv2.model';


export class DiscoLsRenewalPricingItemInitializer extends DiscoPricingItemInitializer {

    initUserInputs(customerContract: BillingLine, prefilledInputs: any, pricingItem: PricingItem) {
        let userInputs = super.initUserInputs(customerContract, prefilledInputs, pricingItem);
        if (pricingItem instanceof ConsumablePricingItem) {
            Object.assign(userInputs, {
                consumableQuantity: customerContract.weeklyQuantity,
            })
        }
        else {
            const foundExchangeRule = prefilledInputs.exchangeRules.find(item => item.key == customerContract.exchangeRule);
            Object.assign(userInputs, {
                exchangeRule: foundExchangeRule || prefilledInputs.exchangeRules[0],
                quantity: customerContract.weeklyQuantity,
            })
        }

        return userInputs;

    }

    getPrefilledInputs(productPricings: ProductPricingV2[], referential: any, customerContract: BillingLine): Record<string, any> {
        let prefilledInputs = this.getCommonPrefilledInputs(productPricings, referential, customerContract);
        const exchangeRules: KeyValue<string, string>[] = [];
        productPricings?.forEach(pp => {
            if (pp.exchangeRule != '' && !exchangeRules.some(e => e.key === pp.exchangeRule)) {
                exchangeRules.push({ key: pp.exchangeRule, value: pp.exchangeRule });
            }
        });
        if (!!customerContract.exchangeRule && !exchangeRules.some(e => e.key === customerContract.exchangeRule)) {
            exchangeRules.push({ key: customerContract.exchangeRule, value: customerContract.exchangeRule });
        }
        Object.assign(prefilledInputs, { exchangeRules });
        return prefilledInputs;
    }

    protected findMatchingProductPricing(productPricings: ProductPricingV2[], pricingItem: PricingItem) {
        return productPricings?.find(pp => pp.frequency === pricingItem.userInputs['frequency'].key
            && Number(pp.minQuantity) <= pricingItem.userInputs['quantity']
            && Number(pp.maxQuantity) >= pricingItem.userInputs['quantity']
            && pp.exchangeRule === pricingItem.userInputs['exchangeRule'].key
        );
    }


    completeProductPricingsWithProduct(cmcProduct: ProductV2, product: ProductV2) {

        let standardProductPricings = this.getStandardProduct(cmcProduct.priceList.productPricings, product.priceList?.productPricings);
        if(standardProductPricings){
            standardProductPricings.forEach(pp => {
                pp['type'] = 'STANDARD';
            });
            cmcProduct.priceList.productPricings = cmcProduct.priceList.productPricings.concat(standardProductPricings);
            cmcProduct['isCmcWithStandardProductPricing'] = true;
        }
    }

    getStandardProduct(cmcProductPricings: ProductPricingV2[], standardProductPricings: ProductPricingV2[]): ProductPricingV2[] {
        return standardProductPricings.filter(standardProductPricing =>
            !cmcProductPricings.some(cmcProductPricing =>
                cmcProductPricing.productPricingDetails['frequency'] === standardProductPricing.productPricingDetails['frequency']
                && cmcProductPricing.productPricingDetails['exchangeRule'] === standardProductPricing.productPricingDetails['exchangeRule']
            )
        );
    }


}
